// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"afec3f6d","248":"996e80c9","298":"02803294","407":"0f4b7050","413":"8babfff6","745":"1cc7a47d","884":"9ee7cd34","959":"ce2a9a19"}[chunkId] + ".chunk.js";
};